import { render, staticRenderFns } from "./CommunityCircleMessage.vue?vue&type=template&id=3ed4b4db&scoped=true&"
import script from "./CommunityCircleMessage.vue?vue&type=script&lang=js&"
export * from "./CommunityCircleMessage.vue?vue&type=script&lang=js&"
import style0 from "./CommunityCircleMessage.vue?vue&type=style&index=0&id=3ed4b4db&scoped=true&lang=css&"
import style1 from "./CommunityCircleMessage.vue?vue&type=style&index=1&id=3ed4b4db&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed4b4db",
  null
  
)

export default component.exports